import { render, staticRenderFns } from "./WebpImage.vue?vue&type=template&id=71ff00c9&scoped=true"
import script from "./WebpImage.vue?vue&type=script&lang=js"
export * from "./WebpImage.vue?vue&type=script&lang=js"
import style0 from "./WebpImage.vue?vue&type=style&index=0&id=71ff00c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ff00c9",
  null
  
)

export default component.exports